import { getDisplayDate } from 'utils/time';

export default class InterventionListIntervention {

  constructor(intervention, userCanSeeSuccessScore) {
    this.intervention = intervention;
    this.userCanSeeSuccessScore = userCanSeeSuccessScore || false;
  }

  get hasPhoto() {
    return this.intervention.hasPhoto;
  }

  get interventionId() {
    return this.intervention.id;
  }

  get name() {
    return this.intervention.name;
  }

  get studentExtId() {
    return this.intervention.studentExtId;
  }

  get studentId() {
    return this.intervention.studentId;
  }

  get studentName() {
    return this.intervention.studentName;
  }

  get successScore() {
    return !this.userCanSeeSuccessScore ? -1 : this.intervention.successScore;
  }

  get type() {
    return this.intervention.category;
  }

  get status() {
    return this.intervention.status;
  }

  /** @deprecated Use get status() instead */
  get cleared() {
     return this.intervention.status;
  }

  get clearedDate() {
    return getDisplayDate(this.intervention.clearDate);
  }

  get clearedBy() {
    return this.intervention.clearedBy;
  }

  get clearedInfo() {
    return this.intervention.clearDate ? `${this.clearedDate} by ${this.clearedBy}` : null;
  }

  get trigger() {
    return this.intervention.trigger;
  }

  get raisedDate() {
    return getDisplayDate(this.intervention.raiseDate);
  }
  get raisedBy() {
    if (this.intervention.origin === 'SYSTEM') return 'System';
    if (this.intervention.origin === 'SURVEY') return `${this.intervention.raisedBy} via Survey`;
    return this.intervention.raisedBy;
  }

  get raisedInfo() {
    return `${this.raisedDate} by ${this.raisedBy}`;
  }

  get assignedDate() {
    return getDisplayDate(this.intervention.assignDate);
  }

  get assignedInfo() {
    if (this.intervention.assignDate === null) return null;
    return `${this.intervention.assignedTo} on ${this.assignedDate}`;
  }

  get dueDate() {
    if (this.intervention.dueDate === null) return null;
    return getDisplayDate(this.intervention.dueDate);
  }

  get studentUuid() {
    return this.intervention.uuid;
  }

}
